"use strict";

var lockScroll = function(elem, e) {
  var scrollTop = elem.scrollTop;
  var scrollHeight = elem.scrollHeight;
  var height = elem.clientHeight;
  var wheelDelta = e.deltaY;
  var isDeltaPositive = wheelDelta > 0;

  if (isDeltaPositive && wheelDelta > scrollHeight - height - scrollTop) {
    elem.scrollTop = scrollHeight;
    return cancelScrollEvent(e);
  } else if (!isDeltaPositive && -wheelDelta > scrollTop) {
    elem.scrollTop = 0;
    return cancelScrollEvent(e);
  }
};

var cancelScrollEvent = function(e) {
  e.stopImmediatePropagation();
  e.preventDefault();
  e.returnValue = false;
  return false;
};

module.exports = lockScroll;



// WEBPACK FOOTER //
// ./app/util/browser/scroll.js